(function() {
    'use strict';

    angular.module('elogbooks.user.quote-requests', []);
})();
